import { AccessCodes } from '@pm2/api';

function findNavigationItems(sitemapState) {
  return sitemapState.rootDescriptors.filter(
    (it) => it.path !== "/" && it.title.trim().length > 0 && !it.hidden && it.accessCode === AccessCodes.ALLOWED
  );
}

export { findNavigationItems };
//# sourceMappingURL=descriptor.get-navigation-items.js.map
